import { notification } from 'antd';
import { Constants } from './constants';
import { AxiosError, AxiosResponse } from 'axios';

const PLACEMENT_BOTTOM_LEFT = 'bottomLeft';

export class PushNotification {

  static info(description: string, message: string = Constants.DEFAULT_CERBERUS_TITLE) : void {
    notification[Constants.INFO_TYPE]({
      description,
      message: message,
      placement: PLACEMENT_BOTTOM_LEFT
    });
  }

  static success(description: string, message: string = Constants.DEFAULT_CERBERUS_TITLE) : void {
    notification[Constants.SUCCESS_TYPE]({
      description,
      message: message,
      placement: PLACEMENT_BOTTOM_LEFT
    });
  }

  static error(description: string, message: string = Constants.DEFAULT_CERBERUS_TITLE) : void {
    notification[Constants.ERROR_TYPE]({
      description,
      message: message,
      placement: PLACEMENT_BOTTOM_LEFT,
      duration: 0
    });
  }

  static warnig(description: string, message: string = Constants.DEFAULT_CERBERUS_TITLE) : void  {
    notification[Constants.WARNING_TYPE]({
      description,
      message: message,
      placement: PLACEMENT_BOTTOM_LEFT,
      duration: 0
    });
  }

  static httpSuccess(response : AxiosResponse) : void {
    if(response && response.status === Constants.SUCCESS_STATUS_CODE){
      this.success(String(response.data));
    }else{
      this.error(String(response.data));
    }
  }

  static httpError(error : AxiosError) : void {
    if(error.response && error.response.status !== Constants.SUCCESS_STATUS_CODE){
      const validationError = error.response.data as Record<string, string[]>;
      if(validationError.errors){
        const messageErro = Object.keys(validationError.errors)
          .map(field => `${field}: ${validationError.errors[field].join(', ')}`)
          .join('; ');
        this.error(messageErro, error.message)
      }
      else
        this.error(String(error.response.data), error.message);
    }
    else if(error.code === Constants.ERROR_NETWORK){
      this.error(error.message, Constants.DEFAULT_ERROR_TITLE);
    }else{
      this.error(Constants.DEFAULT_ERROR_MESSAGE, Constants.DEFAULT_ERROR_TITLE);
    }
  }
}